"use client"

import { useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "../../store"
import { 
  NotificationItem, 
  NotificationPayload, 
  NotificationType, 
  markManyRead, 
  markRead, 
  pop, 
  push, 
  reset 
} from "./slice"

export function useStoreNotification() {
  const dispatch = useAppDispatch()
  const notifications = useAppSelector(state => state.notification_slice.value)

  const unreadCount = useMemo(() => {
    return notifications.filter(item => !item.read).length
  }, [notifications])

  const ofType = useCallback((type: NotificationType) => {
    return notifications.filter(item => item.type === type)
  }, [notifications])

  const pushNotification = useCallback((notification: NotificationPayload & { read?: boolean }) => {
    dispatch(push(notification))
  }, [dispatch])

  const popNotification = useCallback((type: NotificationType, id: string) => {
    dispatch(pop({ type, id }))
  }, [dispatch])

  const markAsRead = useCallback((type: NotificationType, id: string) => {
    dispatch(markRead({ type, id }))
  }, [dispatch])

  const markManyAsRead = useCallback((type: NotificationType, ids: string[]) => {
    dispatch(markManyRead({ type, ids }))
  }, [dispatch])

  const resetNotifications = useCallback((value?: NotificationItem[]) => {
    dispatch(reset(value))
  }, [dispatch])

  return useMemo(() => ({
    notifications,
    unreadCount,
    ofType,
    push: pushNotification,
    pop: popNotification,
    markRead: markAsRead,
    markManyRead: markManyAsRead,
    reset: resetNotifications
  }), [
    notifications, 
    unreadCount, 
    ofType, 
    pushNotification, 
    popNotification, 
    markAsRead, 
    markManyAsRead, 
    resetNotifications
  ])
}